import * as S from '@effect/schema/Schema';
import { Challenge } from '@infl-ts/util-fetch-challenge-list';
import { nullable } from '@infl-ts/util-io-ts';
import { StageTypes } from '@infl-ts/util-use-challenge-player';
import * as t from 'io-ts';
var SystemUser = t.type({
  id: t.string,
  name: t.string
});
var Member = t.type({
  id: t.string,
  name: t.string,
  avatarUrl: nullable(t.string)
});
var Author = t.union([Member, SystemUser]);
var AnswerType = t.keyof({
  Image: null,
  ConvertedVideo: null,
  BrokenVideo: null,
  RawVideo: null,
  File: null,
  Text: null
});
var HTML = t.type({
  html: t.string,
  text: t.string
});
export var PublicResponse = t.type({
  __typename: t.literal('PublicResponse'),
  id: t.string,
  member: Member,
  createdAt: t.string,
  responses: nullable(t.array(t.type({
    question: HTML,
    answer: t.string,
    answerType: AnswerType
  }))),
  stage: t.type({
    id: t.string,
    __typename: StageTypes,
    challenge: Challenge
  })
});
export var Post = t.type({
  id: t.string,
  postNumber: t.number,
  __typename: t.literal('Post'),
  author: Author,
  latestVersion: t.type({
    body: t.string,
    createdAt: t.string
  }),
  topic: t.type({
    id: t.string,
    title: t.string,
    slug: t.string
  })
});
export var Topic = t.type({
  __typename: t.literal('Topic'),
  id: t.string,
  author: Author,
  createdAt: t.string,
  title: t.string,
  slug: t.string,
  posts: nullable(t.type({
    edges: nullable(t.array(t.type({
      node: nullable(t.type({
        latestVersion: t.type({
          body: t.string
        })
      }))
    })))
  }))
});
var FeedActivity = t.union([PublicResponse, Topic, Post]);
export var ActivityFeedQuery = t.type({
  feedItems: t.type({
    pageInfo: t.type({
      hasNextPage: t["boolean"],
      endCursor: t.string
    }),
    edges: nullable(t.array(t.type({
      node: nullable(FeedActivity)
    })))
  })
});
export var ActivityFeedBlockConfig = S.struct({
  typename: S.literal('ActivityFeedBlock'),
  id: S.string,
  hash: S.string
});